import { applyBlockerRules, getBlockerState } from "./content-blocker";
export * from "./types";

export default {
  applyBlockerRules,
  getBlockerState,
};
